<template>
  <div :style="style" ref="container">
    <Signature
      :name="currentUser.nombre"
      :closable="closable"
      @close="$emit('close')"
    >
      <slot>
        <div class="data-item">{{ currentUser.cargo }}</div>
        <div class="data-item">{{ currentUser.iut }}</div>
        <div class="data-item">{{ company.fantasia }}</div>
      </slot>
    </Signature>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

import Signature from '@/febos/global/pdf/components/Signature';
import SignatureBehaviors from '@/febos/global/pdf/mixins/SignatureBehaviors';

export default {
  mixins: [SignatureBehaviors],
  components: {
    Signature,
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  props: {
    closable: { type: Boolean, default: false }
  }
};

</script>
